import BaseApi from '../BaseApi';
import { PromotionsApiConverter } from './PromotionsApiConverter';

class PromotionsApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api`;
    this.converter = new PromotionsApiConverter();
  }

  getPoints = () =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/points`,
      null,
      null,
      this.converter.convertPoints,
    );
}

export default PromotionsApi;
